<template>
    <el-dialog  :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
        <div class="h-dialogImg">
            <div class="h-disTable">
                <div class="h-tableCell">
                    <h1>查看外销预排信息</h1>
                    <p>Modify export forecast information</p>
                </div>
            </div>
        </div>
        <div class="h-formLine" style="width:950px;margin:0 auto">
            <el-form ref="form"
                     :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                <el-form-item label="国家名称" filterable class="h-elformWrap-2" required="">
                    <el-select v-model="saveData.country" class="h-tableInput" disabled="">
                        <el-option v-for="(item,index) in gjCo" :key="index" :label="item" :value="item" >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品型号" class="h-elformWrap-2" required="">
                    <el-select class="h-tableInput" v-model="saveData.productModel" disabled="" @change="selectCode">
                        <el-option v-for="(item,index) in pModel" :key="index" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品编码" class="h-elformWrap-2" required="">
                    <el-select class="h-tableInput" v-model="saveData.productCode" disabled="" :filter-method="dataFilter">
                        <el-option v-for="(item,index) in pCode" :key="index" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="型号属性" class="h-elformWrap-2">-->
                <!--<el-input placeholder="请输入..." class="h-tableInput" v-model="saveData.protype" disabled=""></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="数量" class="h-elformWrap-2" required="">
                    <el-input v-model="saveData.proNumber" placeholder="产品数量" class="h-tableInput" disabled=""
                              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                    </el-input>
                </el-form-item>
                <!--<el-form-item label="使用已预测库存" class="h-elformWrap-2">-->
                <!--<el-select v-model="saveData.useData" clearable placeholder="请选择" allow-create-->
                <!--class="h-tableInput" @change="addUseId()" :multiple="true" :disabled="disabled">-->
                <!--<el-option v-for="(item, index) in saveData.uids" :key="index" :label="item.code"-->
                <!--:value="item.code">-->
                <!--</el-option>-->
                <!--</el-select>-->
                <!--<el-form-item label="常规或改制" class="h-elformWrap-2">-->
                    <!--<brselect category="shifou_dingzhi" :v="saveData.isSpecific"-->
                              <!--v-model="saveData.isSpecific" placeholder="请选择"-->
                              <!--@change="changes()" class="h-tableInput" disabled=""/>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="改制大类" class="h-elformWrap-2" v-if="saveData.isSpecific == '2'">-->
                    <!--<el-input v-if="saveData.isSpecific == 1" v-model="saveData.specific"-->
                              <!--disabled=""-->
                              <!--class="h-tableInput" placeholder="描述"></el-input>-->
                    <!--<el-select v-else v-model="saveData.specific" placeholder="请选择"-->
                               <!--style="width: 100%;" class="h-tableInput" @change="addspecificId()"-->
                               <!--:multiple="true" disabled=""-->
                               <!--clearable filterable>-->
                        <!--<el-option v-for="(item,index) in describe" :key="item.specificId" :label="item.des"-->
                                   <!--:value="item.des">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="改制要求" class="h-elformWrap-2" v-if="saveData.isSpecific == '2'">-->
                    <!--<el-input v-model="saveData.specificReform"-->
                              <!--placeholder="改制要求" disabled=""-->
                              <!--class="h-tableInput">-->
                    <!--</el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="单台价加(元)" class="h-elformWrap-2" v-if="saveData.isSpecific == '2'">-->
                    <!--<el-input placeholder="请输入..." v-model="saveData.reformPriceRmb" disabled=""></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="是否库存改制" class="h-elformWrap-2" >-->
                <!--<el-select class="h-tableInput" v-model="saveData.isReformStock">-->
                <!--<el-option value="0" label="否"></el-option>-->
                <!--<el-option value="1" label="是"></el-option>-->
                <!--</el-select>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="是否有船期" class="h-elformWrap-2" >-->
                <!--<el-select class="h-tableInput" v-model="saveData.isShipDate">-->
                <!--<el-option value="0" label="否"></el-option>-->
                <!--<el-option value="1" label="是"></el-option>-->
                <!--</el-select>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="船期日期" class="h-elformWrap-2">-->
                <!--<el-date-picker v-model="saveData.shippingDate" type="date" :clearable="false"-->
                <!--class="h-tableInput"-->
                <!--value-format="yyyy-MM-dd" :placeholder="saveData.shippingDate"-->
                <!--placeholder="请选择日期" :picker-options="pickerOptions">-->
                <!--</el-date-picker>-->
                <!--</el-form-item>-->
                <el-form-item label="预计交货时间" class="h-elformWrap-2">
                    <el-date-picker v-model="saveData.deliveryDate" type="date" :clearable="false"
                                    class="h-tableInput" disabled=""
                                    value-format="yyyy-MM-dd" :placeholder="saveData.deliveryDate"
                                    placeholder="请选择日期" :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="备注" class="h-elformWrap-2">
                    <el-input v-model="saveData.remark" disabled="" placeholder="备注" class="h-tableInput"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="dialogFormVisible = false">取 消</el-button>
            <!--<el-button class="h-btn h-bBtn h-bggreen" @click="saveTo">暂存</el-button>-->
        </div>
    </el-dialog>
</template>

<script>
    import ss from '../../../../api/SystemService';
    export default {
        name: "wxxiangqingUpdate",
        props: {
            orderNumber: {
                type: String,
                required: true
            }
        },
        data(){
            return{
                orderNumber:'',
                dialogFormVisible:false,
                describe: [
                    {
                        specificId: '1',
                        des: '更改电源线'
                    },
                    {
                        specificId: '2',
                        des: '更改铭牌'
                    },
                    {
                        specificId: '3',
                        des: '外箱加贴唛头等'
                    },
                    {
                        specificId: '4',
                        des: '更改说明书/售后手册/检测报告等'
                    },
                    {
                        specificId: '5',
                        des: '内销型号改外销'
                    },
                    {
                        specificId: '6',
                        des: '拆电池'
                    },
                    {
                        specificId: '7',
                        des: '冰排放水'
                    },
                    {
                        specificId: '8',
                        des: '更改外包装箱'
                    },
                    {
                        specificId: '9',
                        des: '增加USB'
                    },
                    {
                        specificId: '11',
                        des: '增加圆盘记录仪'
                    },
                    {
                        specificId: '0',
                        des: '目录外改制'
                    },
                    {
                        specificId: '12',
                        des: '电动门功能'
                    }
                ],
                ycTable:[],
                ycList:[],
                userRole: [],
                instid: '',
                showhistory: false,
                saveData:{
                    isReformStock:'',
                    // isShipDate:'',
                    // shippingDate:'',
                    proNumber:'',
                    proModel:'',
                    proCode:'',
                    country:'',
                    specificReform:'',
                    reformPriceRmb:'',
                    specific:'',
                    isSpecific:'',
                    protype:'',
                    remark:'',
                    deliveryDate:'',
                    codeOpt:[],
                    modelOpt:[],
                    uids:[],
                    useData:[],
                },
                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                gjCo:[],
                f: {
                    productModel: '',
                    productCode: ''
                },
                pModel: [],
                pCode: [],
                pCodecopy: [],
                items: {},
                disabled:true
            }
        },
        created() {

        },
        methods:{
            saveTo() {
                this.tableData = [];
                this.tableData.push(this.saveData);
                // var f = true;
                // b:
                //     for (var s = 0; s < this.tableData.length; s++) {
                //         for (var c in this.tableData[s]) {
                //             if (c == 'specific') {
                //                 if (this.tableData[s][c] == "" && c == 'specific' && this.tableData[s].isSpecific == 2) {
                //                     this.$msg.msge("您填写的产品中有定制的产品且未输入定制需求!");
                //                     f = false;
                //                     break b;
                //                 }
                //             } else {
                //                 if (this.tableData[s][c] == '' && c == 'specificReform' && this.tableData[s].flag == false) {
                //                     this.$msg.msge("您提交的数据中有改制要求未填写!");
                //                     f = false;
                //                     break b;
                //                 }
                //                 if (this.tableData[s][c] == "" && (c == 'country' || c == 'proModel' || c == 'proCode'
                //                     || c == 'proNumber' || c == 'isSpecific' || c == 'deliveryDate')) {
                //                     console.log(c, "这个未填!")
                //                     this.$msg.msge("您的数据有未填项,请填写数据!");
                //                     f = false;
                //                     break b;
                //                 }
                //             }
                //         }
                //     }
                // if (f) {
                //     var cou = this.$store.getters.dictlist("YLCountry_agent");
                //     for (var i = 0; i < this.tableData.length; i++) {
                //         for (var j = 0; j < cou.length; j++) {
                //             if (cou[j].name == this.tableData[i].country) {
                //                 this.tableData[i].country = cou[j].code
                //             }
                //         }
                //         if (this.tableData[i].isSpecific == 2) {
                //             //循环设置
                //             this.tableData[i].specificReq = _.join(this.tableData[i].specific || [], ",");
                //         } else {
                //             this.tableData[i].specificId = '';
                //             this.tableData[i].specificReq = '';
                //         }
                //
                //         if (this.tableData[i].useData && this.tableData[i].useData != '') {
                //             this.tableData[i].useMeg = _.join(this.tableData[i].useData || [], ",");
                //         } else {
                //             this.tableData[i].useId = '';
                //             this.tableData[i].useMeg = '';
                //         }
                //
                //         this.tableData[i].prolist = [];
                //         this.tableData[i].modelOpt = [];
                //         this.tableData[i].codeOpt = [];
                //
                //         if (!this.tableData[i].specificType || this.tableData[i].specificType == '') {
                //             if (this.tableData[i].isSpecific == 1) {
                //                 this.tableData[i].specificType = '1';
                //             } else {
                //                 var index = this.tableData[i].specificId.indexOf("0");
                //                 console.log(index)
                //                 if(index == -1){
                //                     this.tableData[i].specificType = '1';
                //                 }else{
                //                     this.tableData[i].specificType = '2';
                //                 }
                //             }
                //         }
                //         // console.log(this.tableData[i].specificType,"????");
                //     }
                // console.log(this.tableData,"内容是什么");
                for(var i=0;i<this.tableData.length;i++){
                    this.tableData[i].useNumber = this.tableData[i].proNumber
                }
                ss.waixiao.saveToPre(this.tableData).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.dialogFormVisible = false;
                    this.$parent.query();
                })
                // }
            },
            addspecificId(v) {
                this.saveData.specificId = '';
                this.saveData.reformPriceRmb = '';
                for (var i = 0; i < this.saveData.specific.length; i++) {
                    for (var j = 0; j < this.describe.length; j++) {
                        if (this.saveData.specific[i] == this.describe[j].des) {
                            if (this.describe[j].specificId && this.describe[j].specificId != '') {
                                if (this.saveData.specificId != null && this.saveData.specificId != '') {
                                    this.saveData.specificId = this.saveData.specificId + this.describe[j].specificId + ", "
                                } else {
                                    this.saveData.specificId = this.describe[j].specificId + ", "
                                }
                            }
                            if (this.describe[j].specificId == '9') {
                                if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                    this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 335;
                                } else {
                                    this.saveData.reformPriceRmb = 335;
                                }
                            } else if (this.describe[j].specificId == '11') {
                                if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                    this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 2010;
                                } else {
                                    this.saveData.reformPriceRmb = 2010;
                                }
                            } else if (this.describe[j].specificId == '12') {
                                if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                    this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 5440;
                                } else {
                                    this.saveData.reformPriceRmb = 5440;
                                }
                            } else {
                                if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                    this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 0;
                                } else {
                                    this.saveData.reformPriceRmb = 0;
                                }
                            }
                        }
                    }
                }
                var index = this.saveData.specificId.indexOf("0");
                if(index == -1){
                    this.saveData.flag = true;
                    this.saveData.specificType = '1';
                }else{
                    this.saveData.flag = false;
                    this.saveData.specificType = '2';
                }
                this.$forceUpdate()
            },
            changes(v) {
                if (this.saveData.isSpecific == 1) {
                    this.saveData.specific = '';
                    this.saveData.specificReq = '';
                    this.saveData.specificId = '';
                    this.saveData.specificType = '1';
                    this.saveData.specificReform = '';
                    this.saveData.reformPriceRmb = '';
                }
            },
            addUseId(v) {
                this.saveData.useId='';
                if (this.saveData.useData && this.saveData.useData.length != 0 && this.saveData.uids && this.saveData.uids.length != 0) {
                    for (var i = 0; i < this.saveData.useData.length; i++) {
                        for (var j = 0; j < this.saveData.uids.length; j++) {
                            if (this.saveData.useData[i] == this.saveData.uids[j].name) {
                                if (this.saveData.useId != null && this.saveData.useId != '') {
                                    this.saveData.useId = this.saveData.useId + this.saveData.uids[j].code + ","
                                } else {
                                    this.saveData.useId = this.saveData.uids[j].code + ","
                                }
                            }
                        }
                        this.ycTable = [];
                        for(var t=0;t<this.ycList.length;t++){
                            if(this.ycList[t].id == this.saveData.useData[i]){
                                this.ycTable.push(this.ycList[t]);
                            }
                        }
                    }
                }
                this.$forceUpdate()
            },
            decide() {
                if (this.saveData.productModel != this.items.proModel && this.saveData.productCode != this.items.proCode) {
                    this.items.proModel = this.saveData.productModel;
                    this.items.proCode = this.saveData.productCode;
                    // this.items.describe = [];
                    this.items.specificReq = [];
                    this.items.uids = [];
                    this.items.useData = [];
                    this.items.specific = [];
                    this.items.specificReform = '';
                    this.items.reformPriceRmb = '';
                }
                ss.waixiao.selectProType(this.items.proCode, 2).then(rd => {
                    this.saveData.protype = rd;
                })
                // this.selectDingzhi(this.items);
                this.selectStock(this.items);
            },
            selectStock(v) {
                var obj= {
                    proCode: v.proCode
                }
                ss.waixiao.selectStock(obj).then(rd => {
                    this.ycList = rd;
                    if (rd && rd.length > 0) {
                        for (var i = 0; i < rd.length; i++) {
                            this.saveData.uids.push({
                                code: rd[i].id,
                                name: rd[i].strDes,
                            });
                        }
                    }
                    this.saveData.useData.push(this.saveData.useMeg)
                    this.addUseId();
                })
            },
            dataFilter(val){
                val = val.replace(/\s*/g, "");
                this.productCode = val;
                if (val) { //val存在
                    this.pCode = this.pCodecopy.filter((item) => {
                        if (!!~item.indexOf(val) || !!~item.toUpperCase().indexOf(val.toUpperCase())) {
                            return true
                        }
                    })
                } else { //val为空时，还原数组
                    this.pCode = this.pCodecopy;
                }
            },
            selectCode(v) {
                for (var key in this.items.prolist) {
                    if (this.saveData.productModel == key) {
                        this.saveData.productCode = this.items.prolist[key];
                    }
                }
                this.decide();
            },
            clickmodel(data) {
                this.saveData = data;
                this.saveData.productCode =  this.saveData.proCode;
                this.saveData.productModel =  this.saveData.proModel;
                this.saveData.modelOpt = [];
                this.saveData.codeOpt = [];
                this.saveData.uids = [];
                this.saveData.useData = [];
                if(this.saveData.specificReq && this.saveData.specificReq.length > 3){
                    this.saveData.specific = this.saveData.specificReq.split(",");
                }
                if (this.saveData.country && this.saveData.country != '') {
                    this.f.productModel = this.saveData.proModel;
                    this.f.productCode = this.saveData.proCode;
                    this.items = this.saveData;
                    if (this.saveData.codeOpt.length == 0 || this.saveData.modelOpt.length == 0) {
                        var guojia = '';
                        var guoj = this.$store.getters.dictlist("YLCountry_agent");
                        for (var i = 0; i < guoj.length; i++) {
                            if (guoj[i].name == this.saveData.country) {
                                guojia = guoj[i].code;
                            }
                        }
                        if (!guojia || guojia == '') {
                            guojia = this.saveData.country;
                        }
                        var m = {
                            country: guojia
                        }
                        ss.waixiao.showProduct(m).then(rd => {
                            this.saveData.prolist = rd;
                            for (var key in rd) {
                                this.saveData.modelOpt.push(key);
                                this.saveData.codeOpt.push(rd[key]);
                            }
                            this.pModel = this.saveData.modelOpt;
                            this.pCode = this.saveData.codeOpt;
                            this.pCodecopy = this.saveData.codeOpt;
                            this.disabled = false;
                        })
                    } else {
                        this.pModel = this.saveData.modelOpt;
                        this.pCode = this.saveData.codeOpt;
                        this.pCodecopy = this.saveData.codeOpt;
                        this.disabled = false;
                    }
                    this.addspecificId();
                    this.selectCode();
                } else {
                    this.$msg.msge("请先选择国家！");
                }
            },
            showCountry(data) {
                var country = this.$store.getters.dictlist("YLCountry_agent");
                ss.waixiao.selectCountry().then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        for (var j = 0; j < country.length; j++) {
                            if (country[j].code == rd[i]) {
                                this.gjCo.push(country[j].name);
                            }
                            if(country[j].code == data.country){
                                data.country = country[j].name;
                            }
                        }
                    }
                    this.clickmodel(data)
                })
            },
            isShowDia(parentToChildData,isVastus){
                let self = this
                self.dialogFormVisible =isVastus;
                this.showCountry(parentToChildData);
            },
        }
    }
</script>

<style scoped>

    .h-dialog2{

    }
    .h-dialog2 .h-dialogImg {
        height: 1.62rem;
        background:#007fd8 url(/img/h-dialogImg.471fa846.png) left no-repeat;
        background-size: 7.89rem;
        padding-left: 4.02rem;
    }
    .h-dialog2 /deep/.el-dialog{
        width: 12rem ;
        margin: 0 auto;
    }
    .h-dialog2 .el-dialog__body{
        padding: 1rem 0;
    }
    .h-dialogForm{
        padding:0.25rem 0 0 0
    }
    .h-dialogForm .h-elformWrap-2{
        width:40%;
        margin-right: 3%
    }
    .h-dialog2 /deep/.el-dialog__footer{
        padding-bottom: .2rem
    }

</style>